module.exports = __webpack_public_path__ + "static/media/videoadd.a290125b.png";